export default __webpack_public_path__ + "static/media/barmer.9629bbef.jpg";